import React from 'react';
import LuxityLoader from 'components/LuxityLoader';
import {
  followUpStatuses,
  leadStatuses,
  leadItemStatuses,
  itemOfferChoices,
  openOfferStatuses,
} from 'constants/leadStatuses';
import { getItemSelection } from '../utils/getItemSelection';

export const LeadActionButtons = ({
  lead,
  isSubmitting,
  updateLeadStatus,
  updateFollowUpStatus,
  itemSelections,
}) => {
  const getSelection = (item) => getItemSelection(item, itemSelections);

  const everyItemAnswered = lead.lead_items.every(
    (item) => getSelection(item) !== null,
  );

  const handleUpdateLeadStatus = (status) => {
    const updatedLeadItems = lead.lead_items.map((item) => {
      // A declined item has no payout: sending false would store it as a cash buy.
      if (status === leadStatuses.DECLINED) {
        return {
          item_id: item.id.toString(),
          consignment: null,
          item_status: leadItemStatuses.USER_DECLINED,
        };
      }

      const selection = getSelection(item);
      const declined = selection === itemOfferChoices.DECLINE;

      return {
        item_id: item.id.toString(),
        consignment:
          selection === null || declined
            ? null
            : selection === itemOfferChoices.CONSIGNMENT,
        item_status: declined
          ? leadItemStatuses.USER_DECLINED
          : leadItemStatuses.ACCEPTED,
      };
    });

    updateLeadStatus(lead.id, status, updatedLeadItems);
  };

  return (
    <div className="w-full flex gap-2 justify-end">
      {isSubmitting ? (
        <LuxityLoader />
      ) : (
        <>
          {openOfferStatuses.includes(lead.status) && (
            <>
              <button
                type="button"
                className="text-black focus:outline-none px-4 py-2.5 text-center inline-flex border border-black gap-2 hover:text-white hover:border-white hover:bg-black"
                onClick={() => handleUpdateLeadStatus(leadStatuses.DECLINED)}>
                DECLINE ALL
                <img
                  src="/assets/images/delete.png"
                  alt="delete"
                  width={15}
                  height={15}
                />
              </button>
              <button
                type="button"
                disabled={!everyItemAnswered}
                title={
                  everyItemAnswered
                    ? undefined
                    : 'Choose cash, consignment or decline for every item'
                }
                className="text-black focus:outline-none px-4 py-2.5 text-center inline-flex border border-black gap-2 hover:text-white hover:border-white hover:bg-black disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-black disabled:hover:border-black"
                onClick={() => handleUpdateLeadStatus(leadStatuses.ACCEPTED)}>
                PROCEED
                <img
                  src="/assets/images/checkmark.png"
                  alt="checkmark"
                  width={15}
                  height={15}
                />
              </button>
            </>
          )}

          {lead.status === leadStatuses.ACCEPTED && (
            <button
              disabled={lead.follow_up_status === followUpStatuses.ON_THEIR_WAY}
              type="button"
              className={`focus:outline-none px-4 py-2.5 text-center inline-flex items-center gap-2 ${
                lead.follow_up_status === followUpStatuses.ON_THEIR_WAY
                  ? 'text-[#4FA254] bg-[#EFEFEF] border border-[#EEEEEE]'
                  : 'text-black bg-white border border-black'
              }`}
              onClick={() => updateFollowUpStatus(lead.id)}>
              ON THE WAY
              <img
                src="/assets/svgs/received.svg"
                alt="delete"
                width={15}
                height={15}
              />
            </button>
          )}
        </>
      )}
    </div>
  );
};
